<ng-container>
  <div class="page-title">
    <div [innerHTML]="'AddressInfo.Single.Title' | translate | safe:'html'" class="title"></div>
    <div [innerHTML]="'AddressInfo.Single.SubTitle' | translate | safe:'html'" class="sub-title"></div>
  </div>

  <app-address
    (addressModelChange)="updateUser()"
    [addressModel]="user.addressModel"
    [monitoring]="user.monitoring">
  </app-address>
</ng-container>

<ng-container>
  <div class="page-title">
    <div [innerHTML]="'CitizenshipInfo.Single.Title' | translate | safe:'html'"
         class="title">
    </div>
    <div [innerHTML]="'CitizenshipInfo.Single.SubTitle' | translate | safe:'html'"
         class="sub-title">
    </div>
  </div>

  <app-citizenship
    (citizenshipModelChange)="updateUser()"
    [citizenshipModel]="user.contactModel">
  </app-citizenship>
</ng-container>
